<template>
  <div s>
    <van-index-bar class="custom-index-bar">
      <div v-for="(list, key) in indexAnchorMap" :key="key">
        <van-index-anchor :index="key" />
        <van-cell
          @click="onSelectClick(ele)"
          v-for="ele in list"
          title-class="custom-cell-title"
          :key="ele.expressCompanyCode"
          :title="ele.expressCompanyName"
        />
      </div>
    </van-index-bar>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
  data() {
    return {
      companyList: [],
      rendering: true,
      indexAnchorMap: {
        A: [],
        B: [],
        C: [],
        D: [],
        E: [],
        F: [],
        G: [],
        H: [],
        I: [],
        J: [],
        K: [],
        L: [],
        M: [],
        N: [],
        O: [],
        P: [],
        Q: [],
        R: [],
        S: [],
        T: [],
        U: [],
        V: [],
        W: [],
        X: [],
        Y: [],
        Z: []
      }
    };
  },
  created() {
    const expressMap = localStorage.getItem('ZYYD_EXPRESS_COMPANY_MAP');
    if (expressMap) {
      this.indexAnchorMap = JSON.parse(expressMap);
      this.getExpressCompany(false);
    } else {
      this.getExpressCompany();
    }
  },
  methods: {
    onSelectClick(ele) {
      const { refundId } = this.$route.query;
      this.$router.replace({
        path: '/add-refund-express',
        query: {
          refundId,
          expressCom: ele.expressCompanyName,
          expressComCode: ele.expressCompanyCode
        }
      });
    },
    getExpressCompany(needRender = true) {
      if (needRender) {
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
      }

      this.$fetch.getExpressCompanyList().then((res) => {
        const letterPattern = /[a-zA-Z]+/g;
        const { list = [] } = res;
        const indexAnchorMapTemp = cloneDeep(this.indexAnchorMap);
        this.companyList = list.map((ele) => {
          const matches = ele.expressCompanyNamePinyin.match(letterPattern);
          ele.pinyin = matches[0];
          return ele;
        });
        this.companyList.forEach((ele) => {
          const key = ele.pinyin[0].toLocaleUpperCase() || 'A';
          if (indexAnchorMapTemp[key] && indexAnchorMapTemp[key].length > 0) {
            indexAnchorMapTemp[key].push(ele);
          } else {
            indexAnchorMapTemp[key] = [ele];
          }
        });

        localStorage.setItem('ZYYD_EXPRESS_COMPANY_MAP', JSON.stringify(indexAnchorMapTemp));

        if (needRender) {
          this.indexAnchorMap = indexAnchorMapTemp;
          this.$toast.clear();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.custom-index-bar {
  /deep/ .van-index-bar__sidebar {
    top: 45%;
    .van-index-bar__index {
      line-height: 20px;
      color: #262626;
      &.van-index-bar__index--active {
        color: #1e8dff;
      }
    }
  }

  .custom-cell-title {
    color: #262626;
  }
}
</style>